exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manage-membership-modal_body {\n  text-align: left;\n  padding-top: 20px !important;\n}\n", ""]);

// exports
